const validHeadTags = new Set([
  'SCRIPT',
  'STYLE',
  'LINK',
  'META',
  'TITLE',
  'BASE',
  'NOSCRIPT',
]);

const createScriptElement = (script: HTMLScriptElement) => {
  const scriptElement = document.createElement('script');

  for (const attribute of script.attributes) {
    scriptElement.setAttribute(attribute.name, attribute.value);
  }

  scriptElement.text = script.textContent || '';

  return scriptElement;
};

export const appendToHead = (scriptContent: string) => {
  if (!globalThis?.document) return () => {};

  const temporaryDiv = document.createElement('div');
  temporaryDiv.innerHTML = scriptContent;

  // Store appended nodes for cleanup
  const appendedNodes: HTMLElement[] = [];

  for (const node of temporaryDiv.childNodes) {
    const isValidHeadTag =
      node.nodeType === Node.ELEMENT_NODE &&
      validHeadTags.has((node as HTMLElement).tagName);

    if (!isValidHeadTag) continue;

    const element = node as HTMLElement;

    if (element.tagName === 'SCRIPT') {
      // Special handling for scripts: create a new element so it executes
      const scriptElement = createScriptElement(element as HTMLScriptElement);

      document.head.append(scriptElement);
      appendedNodes.push(scriptElement);
    } else {
      const clone = element.cloneNode(true) as HTMLElement;
      document.head.append(clone);
      appendedNodes.push(clone);
    }
  }

  // Cleanup
  return () => {
    for (const node of appendedNodes) {
      if (document.head.contains(node)) {
        node.remove();
      }
    }
  };
};

export const appendToBody = (scriptContent: string, scriptContainer: HTMLDivElement | null) => {
  if (!globalThis?.document) return () => {};

  const temporaryDiv = document.createElement('div');
  temporaryDiv.innerHTML = scriptContent;

  // Store appended nodes for cleanup
  const appendedScripts: HTMLScriptElement[] = [];
  const targetContainer = scriptContainer || document.body;

  for (const script of temporaryDiv.querySelectorAll('script')) {
    const scriptElement = createScriptElement(script);

    targetContainer.append(scriptElement);
    appendedScripts.push(scriptElement);
  }

  // Cleanup
  return () => {
    for (const script of appendedScripts) {
      if (targetContainer.contains(script)) {
        script.remove();
      }
    }
  };
};
